import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Analytics } from "@vercel/analytics/react"
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { Founder } from './components/Founder';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

const App = () => {

  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <AboutUs />
      <Services />
      <Founder />
      <Contact />
      <Footer />
      <Analytics />
    </div>
  );
};

export default App;